module.exports = __webpack_public_path__ + "d478ffc8cb1f656172cb98a1d12f4dba.riv";